import Vue from 'vue';
import { Dialog } from '@zyf2e/capui-mobile';
// import * as Telescope from '@zyf2e/telescope';

import App from './App.vue';
import router from './router';
import store from './store';
import Fetch from './api';
import Util from './util';
import wx from './util/wechatHelper.js';
import './util/vant';
import directives from './directives';

import './filter';
import './styles/mixins.scss';
import './styles/variables.less';

const FastClick = require('fastclick');
const str = navigator.userAgent.toLowerCase();
const ver = str.match(/cpu iphone os (.*?) like mac os/);

// const VConsole = require('vconsole');
// eslint-disable-next-line
// new VConsole();

if (!ver) {
  //非IOS系统
  // 引入fastclick 做相关处理
  clickHandle();
} else {
  if (parseInt(ver[1]) < 11) {
    // 引入fastclick 做相关处理
    clickHandle();
  }
}

directives.forEach((item) => {
  Vue.directive(item.name, item.direct);
});
Vue.directive('track-event', Telescope.vTrackEvent);
// Vue.directive('track-view', Telescope.vTrackView);
Vue.directive('track-page', Telescope.vTrackPage);

Telescope.setConfig({
  autoTrackClick: false,
  trackKey: 'a76a08345e4d3cc6585e5305b40d52ecb9171455b6ba217e4c84e021eb7b4db8',
  version: '1.0.0'
});

window.Telescope = Telescope || {};

function clickHandle() {
  window.addEventListener(
    'load',
    function () {
      FastClick.attach(document.body);
    },
    false
  );
}

Vue.prototype.$fetch = Fetch;
Vue.prototype.$util = Util;

router.beforeEach((to, from, next) => {
  if (history.scrollRestoration) {
    history.scrollRestoration = 'manual';
  }
  console.log(to);
  if (to.name === 'home') {
    store.commit('order/setSiderbarActive', 0);
  }
  wx.hideOptionMenu();
  document.title = to.meta.title || '智云医道';
  if (window.util.inWechat) {
    if (!to.meta.noAuth) {
      wx.wechatAuth(() => {
        if (to.meta.getUserInfo && Object.keys(store.state.userInfo).length <= 0) {
          store
            .dispatch('getUserInfo')
            .then(() => {
              if (!store.getters.mobileBinded && store.getters.basicInfoFilled && to.name != 'BindingInfo') {
                router.push({ name: 'BindingInfo' });
                return;
              }
              next();
            })
            .catch(() => {
              next();
            });
          return;
        }

        next();
      });
    } else {
      next();
    }
  } else {
    Dialog.alert({
      title: '提示',
      message: '请在微信中打开页面'
    });
  }
});

router.afterEach((to) => {
  window?.webVitals?.zyCustomContentfulPaint();

  if (to.meta.telescope) {
    Telescope.trackPage({ trackId: to.meta.telescope });
  }
});

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app');

// Util.loadScript('./js/iconfont.js');

window.Vue = Vue;
// window.requestAnimationFrame = null
// requestAnimationFrame 降级方案
if (!Date.now)
  Date.now = function () {
    return new Date().getTime();
  };

(function () {
  'use strict';

  var vendors = ['webkit', 'moz'];
  for (var i = 0; i < vendors.length && !window.requestAnimationFrame; ++i) {
    var vp = vendors[i];
    window.requestAnimationFrame = window[vp + 'RequestAnimationFrame'];
    window.cancelAnimationFrame = window[vp + 'CancelAnimationFrame'] || window[vp + 'CancelRequestAnimationFrame'];
  }
  if (
    /iP(ad|hone|od).*OS 6/.test(window.navigator.userAgent) || // iOS6 is buggy
    !window.requestAnimationFrame ||
    !window.cancelAnimationFrame
  ) {
    var lastTime = 0;
    window.requestAnimationFrame = function (callback) {
      var now = Date.now();
      var nextTime = Math.max(lastTime + 16, now);
      return setTimeout(function () {
        callback((lastTime = nextTime));
      }, nextTime - now);
    };
    window.cancelAnimationFrame = clearTimeout;
  }
})();
